/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmPrimaryContactData
 */
export interface CrmPrimaryContactData {
    /**
     * 
     * @type {string}
     * @memberof CrmPrimaryContactData
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmPrimaryContactData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmPrimaryContactData
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmPrimaryContactData
     */
    phone?: string | null;
    /**
     * 
     * @type {CrmPrimaryContactDataContactOriginEnum}
     * @memberof CrmPrimaryContactData
     */
    contactOrigin?: CrmPrimaryContactDataContactOriginEnum;
}


/**
 * @export
 */
export const CrmPrimaryContactDataContactOriginEnum = {
    Observed: 'observed',
    LegacyInferred: 'legacy_inferred',
    Manual: 'manual',
    Unknown: 'unknown'
} as const;
export type CrmPrimaryContactDataContactOriginEnum = typeof CrmPrimaryContactDataContactOriginEnum[keyof typeof CrmPrimaryContactDataContactOriginEnum];


/**
 * Check if a given object implements the CrmPrimaryContactData interface.
 */
export function instanceOfCrmPrimaryContactData(value: object): value is CrmPrimaryContactData {
    return true;
}

export function CrmPrimaryContactDataFromJSON(json: any): CrmPrimaryContactData {
    return CrmPrimaryContactDataFromJSONTyped(json, false);
}

export function CrmPrimaryContactDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmPrimaryContactData {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contactOrigin': json['contactOrigin'] == null ? undefined : json['contactOrigin'],
    };
}

export function CrmPrimaryContactDataToJSON(json: any): CrmPrimaryContactData {
    return CrmPrimaryContactDataToJSONTyped(json, false);
}

export function CrmPrimaryContactDataToJSONTyped(value?: CrmPrimaryContactData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'contactOrigin': value['contactOrigin'],
    };
}

